<template>
    <div class="h-full">
        <div class="content p-4 h-full" :class="contentClass" ref="content">
            <slot />
        </div>
    </div>
</template>

<script>
import { eventBus } from '@/eventBus';

export default {
    props: {
        contentClass: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        modalsOpen: 0,
    }),
    created() {
        eventBus.$on('pageFlip', this.scrollTop);
        eventBus.$on('modalOpen', this.modalOpens);
        eventBus.$on('modalClose', this.modalCloses);
    },
    beforeDestroy() {
        eventBus.$off('pageFlip', this.scrollTop);
        eventBus.$off('modalOpen', this.modalOpens);
        eventBus.$off('modalClose', this.modalCloses);
    },
    methods: {
        scrollTop() {
            // https://popmotion.io/blog/20170704-manually-set-scroll-while-ios-momentum-scroll-bounces/
            this.$refs.content.style['-webkit-overflow-scrolling'] = 'auto';
            this.$refs.content.scrollTop = 0;
            this.$refs.content.style['-webkit-overflow-scrolling'] = 'touch';
        },
        modalOpens() {
            if (this.modalsOpen === 0) {
                this.disableScrolling();
            }
            this.modalsOpen += 1;
        },
        modalCloses() {
            this.modalsOpen -= 1;
            if (this.modalsOpen === 0) {
                this.enableScrolling();
            }
        },
        disableScrolling() {
            this.$refs.content.style['-webkit-overflow-scrolling'] = 'auto';
            this.$refs.content.classList.add('overflow-hidden');
        },
        enableScrolling() {
            this.$refs.content.classList.remove('overflow-hidden');
            this.$refs.content.style['-webkit-overflow-scrolling'] = 'touch';
        },
    },
};
</script>
